module.exports = {

    apiUrl: 'https://testing-server.payrollpanda.my/api',

    logLevel: 'trace',

    bigCompanyThreshold: 15,

    defaultMaxEmployeeCount: 100,

    /* The date in which a 'payroll period' starts. If 15 is selected, the
     * app would consider all payrolls after the 15th to be of that calendar
     * month. Payrolls before ran before the 15th belong to the previous
     * calendar month. IE running a payroll on aug 13th means it will be
     * considered july's payroll, running it on aug 16th means it will be
     * considered august's payroll.
     */
    periodStartDate: 15
};



// WEBPACK FOOTER //
// ./app/config/testing.js